import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      zIndex: 1,
      justifyContent: 'center',
      maxWidth: 680,
    },
    content: {
      marginBottom: '-19px!important',
    },
    title: {
      zIndex: 2,
      backgroundColor: '#a51614',
      padding: '12px 0',
      color: '#fff',
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      fontWeight: 400,
      textTransform: 'uppercase',
      height: 50,
      width: '100%',
    },
    gridNameCity: {
      zIndex: 2,
      backgroundColor: '#fff',
      display: 'flex',
      cursor: 'pointer',
      width: '100%',
      padding: '0 20px',

      justifyContent: 'space-between!important',
    },
    nameCity: {
      margin: 0,
      color: '#4d5055',
      fontSize: 18,
    },
  }),
);

export default useStyles;
